import { render, staticRenderFns } from "./text.vue?vue&type=template&id=0a934fd9&scoped=true&"
import script from "./text.js?vue&type=script&lang=js&"
export * from "./text.js?vue&type=script&lang=js&"
import style0 from "./text.css?vue&type=style&index=0&id=0a934fd9&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a934fd9",
  null
  
)

export default component.exports